import { IUserKey } from '@/contracts/system-modules/auth/key/IUserKey'
import { EnumUserKeyError } from '@/contracts/system-modules/auth/key/EnumUserKeyError'
import { base64UrlToBytes, bytesToBase64Url } from '@/helpers/base64url'

// AES-KW создан для шифрования ключей: без nonce и сам проверяет целостность
const WRAP_ALGORITHM = 'AES-KW'
const DATA_KEY_ALGORITHM: AesKeyAlgorithm = { name: 'AES-GCM', length: 256 }
const DATA_KEY_USAGES: KeyUsage[] = ['encrypt', 'decrypt']

export class UserKey implements IUserKey {
  private key: CryptoKey

  constructor(key: CryptoKey) {
    this.key = key
  }

  async wrap(key: CryptoKey): Promise<string> {
    const wrapped = await crypto.subtle.wrapKey('raw', key, this.key, WRAP_ALGORITHM)

    return bytesToBase64Url(new Uint8Array(wrapped))
  }

  /** Любой сбой WebCrypto и разбора строки — чужой ключ или испорченная строка */
  async unwrap(wrapped: string): Promise<CryptoKey> {
    try {
      return await crypto.subtle.unwrapKey('raw', base64UrlToBytes(wrapped), this.key, WRAP_ALGORITHM, DATA_KEY_ALGORITHM, false, DATA_KEY_USAGES)
    } catch {
      throw new Error(EnumUserKeyError.WRONG_KEY)
    }
  }
}
